import React from 'react';
import {useTranslate} from '../../../hooks';
import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import {IconBadge} from '../../../components';
import {PostponeOfferDialogRoutes} from './PostponeOfferDialog';
import {
  formatDate,
  useCountry,
  useFlexTransactions,
} from '@resurs-internal/rb-app-api';
import {BaseList} from '@resurs-internal/mui';

export const PostponeOfferDialogSuccess: React.FC<{
  navigate: (key: PostponeOfferDialogRoutes) => void;
}> = ({navigate}) => {
  const country = useCountry();
  const translate = useTranslate();
  const flex = useFlexTransactions('postpone');
  const activated = flex.query.data?.filter(
    (e) => e?.postponementStatus?.applied,
  );

  const isFlexActivated = Boolean(flex.sum?.amount);
  return (
    <>
      <DialogContent>
        <Stack spacing={2} alignItems={'center'}>
          <IconBadge type={'font'} icon={'check-circle'} size={'xl'} />
          <Typography typography={'h4'} textAlign={'center'}>
            {isFlexActivated
              ? translate('postpone.offer.success.subtitle')
              : translate('postpone.offer.success.empty.subtitle')}
          </Typography>
          <Typography typography={'body1'}>
            {isFlexActivated
              ? translate('postpone.offer.success.description', [
                  country.formatDate(flex.dueDate),
                ])
              : translate('postpone.offer.success.empty.subtitle')}
          </Typography>
          <BaseList
            sx={{
              width: '100%',
              display: isFlexActivated ? undefined : 'none',
            }}
            items={[
              ...(activated?.map((e) => ({
                id: e.id,
                title: e.merchantName ?? '',
                subtitle: formatDate(e.transactionDate),
                endAdornment: (
                  <Typography typography={'subtitle1'}>
                    {country.formatAmount(e.amount)}
                  </Typography>
                ),
              })) ?? []),
              {
                id: 'total',
                title: 'Total',
                hidden: !flex.sum?.amount,
                endAdornment: (
                  <Typography typography={'h4'}>
                    {country.formatAmount(flex.sum)}
                  </Typography>
                ),
              },
            ]}
          />
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          color={'secondary'}
          variant={'text'}
          onClick={() => navigate('update')}>
          {translate('common.back')}
        </Button>
        <Button
          color={'primary'}
          variant={'text'}
          onClick={() => navigate('close')}>
          {translate('common.close')}
        </Button>
      </DialogActions>
    </>
  );
};
